import { Button, PlusIcon } from "melco-ui";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useUploadInputFormat } from "../../hooks/inputFormats/useUploadInputFormat";
import { useConfirmAddInputFormat } from "../../hooks/inputFormats/useConfirmAddInputFormat";

export const AddInputFormatButton: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [uploadInputFormat, isLoading] = useUploadInputFormat();

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      for (const file of acceptedFiles) {
        try {
          const inputFormat = await uploadInputFormat(file);

          if (inputFormat) {
            navigate(`/input-formats/${inputFormat.id!}`);
          }
        } catch (error) {}
      }
    },
    [uploadInputFormat, navigate]
  );

  const { getInputProps, open } = useDropzone({
    multiple: false,
    onDrop,
    noClick: true,
    noKeyboard: true,
  });

  const confirmAddInputFormat = useConfirmAddInputFormat(open);

  return (
    <>
      <input {...getInputProps()} />

      <Button
        key="input-format-add"
        type="primary"
        icon={<PlusIcon />}
        onClick={confirmAddInputFormat}
        loading={isLoading}
      >
        {t("inputFormats.actions.add.button")}
      </Button>
    </>
  );
};
